import { getIconAsBgImage, getLabelValue, getMatchDateExtended } from '@sportal365/smp-widget-utils';
import { ILabels, IMatch, SDKOptions, WidgetTypes } from '../../../../packages/types/common';
import { IFootballConfig } from '../../../../packages/types/football';
import { MATCHES_H2H, STANDINGS, TEAM_H2H } from '../../../../packages/constants/widgetIds';

export const generateTabLinksStyles = (isActive: boolean, isMobileSize: boolean, isUpcomingMatch: boolean): React.CSSProperties => {
  const result: React.CSSProperties = {
    display: 'inline-flex',
    height: '26px',
    padding: '8px 16px',
    justifyContent: 'center',
    alignItems: 'center',
    outline: 'none',
    cursor: 'pointer',
    color: 'var(--colors-tabTextColor)',
    backgroundColor: 'var(--colors-tabBackgroundColor)',
    fontFamily: 'var(--fonts-primaryFontFamily)',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    margin: 'auto 0',
    gap: '10px',
    borderRight: '1px solid var(--colors-tabMenuBorderColor)',
    borderBottom: '1px solid var(--colors-tabMenuBorderColor)',
    flex: isMobileSize ? '0 1 auto' : '1 1 auto',
    whiteSpace: 'nowrap',
  };

  if (isActive) {
    return {
      ...result,
      color: 'var(--colors-tabActiveTextColor)',
      backgroundColor: 'var(--colors-tabActiveBackgroundColor)',
      borderBottom: '1px solid var(--colors-tabActiveBackgroundColor)',
    };
  }

  return result;
};

export const extractMatchInformation = (match: IMatch, dataLabels: ILabels | undefined, sdkOptions: SDKOptions) => {
  return {
    dateTime: {
      label: getLabelValue(dataLabels?.match_info_time, 'Date and time'),
      value: match.kickoffTime ? getMatchDateExtended(match.kickoffTime, sdkOptions) : undefined,
      icon: getIconAsBgImage('calendar'),
    },
    venue: {
      label: getLabelValue(dataLabels?.match_info_venue, 'Venue'),
      value: match?.venue?.name || undefined,
      icon: getIconAsBgImage('venue'),
    },
    referee: {
      label: getLabelValue(dataLabels?.match_info_referee, 'Referee'),
      value: match?.referees && match?.referees.length > 0 ? match.referees[0].name : undefined,
      icon: getIconAsBgImage('referee_whistle'),
    },
    spectators: {
      label: getLabelValue(dataLabels?.match_info_spectators, 'Attendance'),
      value: `${match?.spectators}` || undefined,
      icon: getIconAsBgImage('attendance'),
    },
    competition: {
      label: getLabelValue(dataLabels?.match_info_competition, 'Competition'),
      value: `${match?.season?.tournament?.name} ${match?.season?.name}` || undefined,
      icon: getIconAsBgImage('competition'),
      additionalAsset: match?.season?.tournament?.assets?.logo?.url || undefined,
    },
  };
};

export const generateCoreConfigInternalProps = (config: IFootballConfig | undefined, widgetId: string) => {
  const internalProps = {
    dataWidgetType: WidgetTypes.EVENT,
    dataWidgetId: widgetId,
  };

  switch (widgetId) {
    case TEAM_H2H:
    case MATCHES_H2H:
      internalProps.dataWidgetType = WidgetTypes.H2H;
      break;
    case STANDINGS:
      internalProps.dataWidgetType = WidgetTypes.TOURNAMENT;
      break;
    default:
      internalProps.dataWidgetType = WidgetTypes.EVENT;
      break;
  }

  return {
    ...(config as IFootballConfig),
    ...internalProps,
  };
};

export const generateSimpleId = () => {
  return Math.random().toString(36).substr(2, 9);
};
